module.exports = __webpack_public_path__ + "static/media/img10.0b0029b4.jpg";